export default "__VITE_ASSET__DsCEeTnW__"